import React, { ChangeEvent } from "react";
import CurrenciesEnum from "../../../models/CurrenciesEnum";
import OwLabel from "../OwLabel/OwLabel";
import OwSelectOption from "../OwSelectOption/OwSelectOption";

type Props = {
    selectedCurrencyId?: number;
    updateCurrencyId: (e: ChangeEvent<any>) => void;
    wrapperClassName?: string;
};

export const CurrencySelect = (props: Props) => {
    const currencyOptions = [
        { title: "USD", value: CurrenciesEnum.USD },
        { title: "CAD", value: CurrenciesEnum.CAD },
        { title: "EUR", value: CurrenciesEnum.EUR },
        { title: "GBP", value: CurrenciesEnum.GBP },
        { title: "JPY", value: CurrenciesEnum.JPY },
        { title: "AUD", value: CurrenciesEnum.AUD },
        { title: "MXN", value: CurrenciesEnum.MXN },
        { title: "COP", value: CurrenciesEnum.COP },
    ];

    const handleChange = (e: ChangeEvent<any>) => {
        props.updateCurrencyId(e);
    };

    return (
        <div className={"CurrencySelect"}>
            <OwLabel title={"currency"} />
            <div>
                <OwSelectOption
                    name={"currency_id"}
                    fn={handleChange}
                    options={currencyOptions}
                    titleProp={"title"}
                    valueProp={"value"}
                    selectedOption={props.selectedCurrencyId}
                    hasSelectedOptionProp={false}
                />
            </div>
        </div>
    );
};
